import React, { ChangeEvent, useState, forwardRef } from 'react';
import { Button, Icon, Input } from '@iwoca/orion';
import { isAfter } from 'date-fns';

import styles from './DateInput.module.css';

export const DateInput = forwardRef<
  HTMLButtonElement,
  {
    toggleCalendar: (isOpen: boolean) => void;
    handleChange: (newDate: Date) => void;
    selectedDate: Date | null;
    setSelectedDate: (value: React.SetStateAction<Date | null>) => void;
    defaultDate?: string;
  }
>(
  (
    {
      toggleCalendar,
      handleChange,
      selectedDate,
      setSelectedDate,
      defaultDate,
    },
    ref,
  ) => {
    const [dateInputValue, setDateInputValue] = useState(defaultDate);

    const selectedDateAsString = selectedDate?.toISOString().split('T', 1)[0];

    const handleDateChange = (e: ChangeEvent<HTMLInputElement>) => {
      const dateAsString = e.target.value;
      const updatedDate = new Date(dateAsString);

      if (isAfter(updatedDate, new Date())) {
        handleChange(updatedDate);
      }
      setDateInputValue(dateAsString);
      if (!selectedDate) {
        return;
      }
      setSelectedDate(null);
    };

    return (
      <div className={styles.dateInputContainer}>
        <Input
          className={styles.dateInput}
          type="date"
          data-testid="data-picker-input"
          value={selectedDateAsString ? selectedDateAsString : dateInputValue}
          onChange={handleDateChange}
        />
        <div className={styles.buttonContainer}>
          <Button
            className={styles.dateInputButton}
            variant="tertiary"
            onClick={() => toggleCalendar(true)}
            data-testid="data-picker-input-button"
            ref={ref}
          >
            <Icon icon="calendarOutline" />
          </Button>
        </div>
      </div>
    );
  },
);

DateInput.displayName = 'DateInput';
